<svg width="20" height="20" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M6 3C6 2.44772 6.44772 2 7 2C7.55228 2 8 2.44772 8 3V4H12V3C12 2.44772 12.4477 2 13 2C13.5523 2 14 2.44772 14 3V4H16C17.1046 4 18 4.89543 18 6V16C18 17.1046 17.1046 18 16 18H4C2.89543 18 2 17.1046 2 16V6C2 4.89543 2.89543 4 4 4H6V3ZM4 16V7H16V16H4ZM6 9V11H8V9H6ZM8 12V14H6V12H8ZM11 9H9V11H11V9ZM9 12H11V14H9V12ZM14 11V9H12V11H14ZM12 14V12H14V14H12Z"
  />
</svg>
